export default __webpack_public_path__ + "images/K8.27b6cba.png";